import { TShirtSize } from './types'

const marginOrPaddingClasses = (
  marginOrPadding: 'm' | 'p',
  all: TShirtSize | undefined,
  b: TShirtSize | undefined,
  t: TShirtSize | undefined,
  l: TShirtSize | undefined,
  r: TShirtSize | undefined,
  x: TShirtSize | undefined,
  y: TShirtSize | undefined,
  base: string,
): string[] => {
  const modifiers: string[] = []

  if (all) {
    modifiers.push(`${base}--${marginOrPadding}-${all}`)
  } else {
    if (x) {
      modifiers.push(`${base}--${marginOrPadding}x-${x}`)
    } else {
      if (l) {
        modifiers.push(`${base}--${marginOrPadding}l-${l}`)
      }
      if (r) {
        modifiers.push(`${base}--${marginOrPadding}r-${r}`)
      }
    }
    if (y) {
      modifiers.push(`${base}--${marginOrPadding}y-${y}`)
    } else {
      if (b) {
        modifiers.push(`${base}--${marginOrPadding}b-${b}`)
      }
      if (t) {
        modifiers.push(`${base}--${marginOrPadding}t-${t}`)
      }
    }
  }

  return modifiers
}

export const marginClasses = (
  m: TShirtSize | undefined,
  mb: TShirtSize | undefined,
  mt: TShirtSize | undefined,
  ml: TShirtSize | undefined,
  mr: TShirtSize | undefined,
  mx: TShirtSize | undefined,
  my: TShirtSize | undefined,
  base: string,
): string[] => {
  return marginOrPaddingClasses('m', m, mb, mt, ml, mr, mx, my, base)
}

export const paddingClasses = (
  p: TShirtSize | undefined,
  pb: TShirtSize | undefined,
  pt: TShirtSize | undefined,
  pl: TShirtSize | undefined,
  pr: TShirtSize | undefined,
  px: TShirtSize | undefined,
  py: TShirtSize | undefined,
  base: string,
): string[] => {
  return marginOrPaddingClasses('p', p, pb, pt, pl, pr, px, py, base)
}
